import { CampaignTabType } from '@/pages/campaigns/campaigns.page.utils';
import { create } from 'zustand';

export type CampaignsManagerStore = {
	refreshTable?: number;
	setValue: (value: Partial<Omit<CampaignsManagerStore, 'setValue'>>) => void;
	tab: CampaignTabType;
	setTab: (tab: CampaignTabType) => void;
};

export const useCampaignsTableStore = create<CampaignsManagerStore>((set, get) => ({
	refreshTable: undefined,
	setValue: (value) => set(value),
	tab: (() => {
		const query = new URLSearchParams(window.location.search);
		const tab = query.get('tab');
		return (tab as CampaignTabType) || 'campaigns';
	})(),
	setTab: (tab) => {
		const query = new URLSearchParams(window.location.search);
		query.set('tab', tab);
		window.history.pushState({}, '', `${window.location.pathname}?${query.toString()}`);
		set({ tab });
	},
}));
